import React, { useState } from 'react'
import ArrowBottomIcon from '../../../../../../../Assets/Images/icons/arrowBottom'
import { useEffect } from 'react'

const styles = {
  container: { display: 'flex', flexDirection: 'column', gap: '8px' },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  title: {
    color: '#707087',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '18px',
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
  },
  error: { color: 'red' },
  arrow: isExpanded => ({
    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  }),
}

const ExpandableRow = ({ children, title, hasError }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  useEffect(() => {
    if (hasError) {
      setIsExpanded(true)
    }
  }, [hasError])
  return (
    <div style={styles.container}>
      <div style={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
        <div style={styles.title}>
          {title}
          {hasError && <div style={styles.error}>*</div>}
        </div>{' '}
        <div style={styles.arrow(isExpanded)}>
          <ArrowBottomIcon />
        </div>
      </div>
      {isExpanded && children}
    </div>
  )
}

export default ExpandableRow
